import images from "../../../images";

export const QuestionCard = ({
  name,
  type,
  question,
  iconUrl,
  options = [],
}) => {
  return (
    <article className="p-3 w-full bg-white rounded-xl border border-solid border-stone-200 max-w-[396px]">
      <header className="flex gap-10 justify-between items-center w-full">
        <div className="flex gap-1 items-center self-stretch my-auto text-sm font-medium text-indigo-600">
          <img
            src={images.QuestionIconQuestResult}
            className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square"
            alt="Question icon"
          />
          <h2 className="self-stretch my-auto">{name}</h2>
        </div>
        <span className="gap-2.5 self-stretch px-2.5 py-1 my-auto text-xs leading-none whitespace-nowrap bg-yellow-50 rounded-md min-h-6 text-neutral-500 max-w-[80px]">
          {type}
        </span>
      </header>
      <p className="mt-3 text-xs text-neutral-500">{question}</p>
      {options.length > 0 && (
        <ul className="mt-2 space-y-1 text-xs text-neutral-500">
          {options.map((option) => (
            <li
              className=" border  flex items-start p-2 rounded-xl"
              key={option.id}
            >
              {option.option_text}
            </li>
          ))}
        </ul>
      )}
    </article>
  );
};
